
export default {
  name: "Tooltip",
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    tips: {
      type: Array,
      default: () => []
    },
    customStyle: [Object, Promise]
  },
  data() {
    return {
      isHover: false,
      tipStyle: {}
    }
  },
  computed: {
    showTips() {
      if (this.trigger !== "hover") return true
      if (this.isHover) return true
      return false
    }
  },
  watch: {
    // 兼容customStyle为promise的情况
    customStyle: {
      async handler(value) {
        this.tipStyle = await value
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleMouseover() {
      if (this.trigger !== "hover") return
      this.isHover = true
    },
    handleMouseleave() {
      if (this.trigger !== "hover") return
      this.isHover = false
    }
  }
}
